import { AxiosResponse } from 'axios'
import { API } from '../config'
import { PendingRecordDTO, PendingRecordUpdateDTO } from 'src/dto/record.dto'

const BASE_URL = '/tabelaMovimentacaoValidacao'

export type GetPendingRecordListParams = {
  tabela?: string | null
  itemPerPage?: number
  status?: string | null
  dataInicial?: string | null
  dataFim?: string | null
  tokenPage?: string
}
export class RecordService {
  public async getPendingRecords(
    farmId: string,
    params?: GetPendingRecordListParams
  ): Promise<AxiosResponse<PendingRecordDTO[]>> {
    return await API.get<PendingRecordDTO[]>(`${BASE_URL}/${farmId}`, { params })
  }

  public async getTotalCountPendingRecord(
    farmId: string,
    params?: GetPendingRecordListParams
  ): Promise<{ totalPages: number; Total: number }> {
    const response = await API.get<{ totalPages: number; Total: number }>(
      `/entity/countPages/MovementValidationTable/${farmId}`,
      { params }
    )
    return response.data
  }

  public async updatePendingRecord(
    farmId: string,
    pendingRecordDto: PendingRecordUpdateDTO[]
  ): Promise<AxiosResponse<void>> {
    return await API.put(`${BASE_URL}/${farmId}`, pendingRecordDto)
  }

  public async getRecordById(
    farmId: string,
    recordId: string,
    params?: {
      status?: 'Rejeitado' | 'Processado' | 'Pendente'
    }
  ): Promise<AxiosResponse<PendingRecordDTO[]>> {
    return await API.get(`${BASE_URL}/${farmId}/${recordId}/get`, { params })
  }

  public async getRecordFromTableById(
    table: string,
    farmId: string,
    recordId: string
  ): Promise<AxiosResponse<PendingRecordDTO>> {
    return await API.get(`${BASE_URL}/${table}/${farmId}/${recordId}/getId`)
  }
}
